import * as React from 'react';
import { RadioButton, IconTooltip } from 'common--design-library';
import { translation } from 'easit--localization';

export interface IAccountTypeKey {
    id: string,
    freeTicketId?: number | Long
}

export interface IAccountTypesProps {
    availableAccountTypes: {
        key: IAccountTypeKey,
        name: string,
        hint: string,
        canBeUsedByPlayer: boolean,

        areKeysEqual: (keyToCompare: IAccountTypeKey) => boolean
    }[];
    selectedAccountType: IAccountTypeKey;

    setAcountType: (key: IAccountTypeKey) => void;

    getFreeTicketBonusUrl: () => string;
}

export const AccountTypes: React.FC<IAccountTypesProps> = (props: IAccountTypesProps) => {
    let freeTicketSeparatorRendered = false;

    //TODO_FT: pro hint testovat jestli neobsahuje tag <script /> Inspirovat se u chatu react nebo server
    const renderFreeTicketTooltip = (accountTypeKey: IAccountTypeKey, targetKey: string, hint: string) => {
        if (accountTypeKey.freeTicketId) {
            return <IconTooltip
                placement="right"
                allowOnTouchScreen
                targetid={`iconinfo-${targetKey}`}
                target={
                    <span id={`iconinfo-${targetKey}`} className="etip-info ml-1" />
                }
                className="mobile-event-detail-tooltip"
            >
                <div dangerouslySetInnerHTML={{ __html: hint }} />
                <div className="mt-2">
                    <a href={props.getFreeTicketBonusUrl()}><button className="btn btn-secondary">Bonus</button></a>
                </div>
            </IconTooltip>
        }
        return null;
    };

    const renderFreeTicketSection = (isFreeTicketAccount: boolean) => {
        if (isFreeTicketAccount && !freeTicketSeparatorRendered) {
            freeTicketSeparatorRendered = true;
            return <div className="mt-2">{translation().bet_FreeTicketSection}</div>
        }
        return null;
    }

    //TODO_FT:Styly Patrik Grubner
    return (props.availableAccountTypes && props.availableAccountTypes.length > 0)
        ? <>
            <div className="ticket-section-header mt-2 px-2">{translation().bet_ProductName}</div>
            <div className="px-2 pt-2" data-test-role="products">
                {
                    props.availableAccountTypes.map(accountType => {
                        let key: string = accountType.key.id + '-' + (accountType.key.freeTicketId ? accountType.key.freeTicketId.toString() : "");

                        return <React.Fragment key={key}>
                            {renderFreeTicketSection(accountType.key.freeTicketId !== null)}
                            <RadioButton isChecked={accountType.areKeysEqual(props.selectedAccountType)}
                                onChangehandler={() => { props.setAcountType(accountType.key) }}
                                RoleForTest="products__item"
                                isDisabled={!accountType.canBeUsedByPlayer}
                                customClass={accountType.key.freeTicketId ? 'px-3' : ''}
                            >
                                {accountType.name}
                                {renderFreeTicketTooltip(accountType.key, key, accountType.hint)}
                            </RadioButton>
                        </React.Fragment>
                    })
                }
            </div >
        </>
        : null
}